import React from 'react';
import type { ComponentType } from 'react';
import type { SportType } from '@/api/generated/model';
import type { PlayerProfileFormProps } from './types';
import { FootballPlayerProfileForm } from './FootballPlayerProfileForm';
import { HockeyPlayerProfileForm } from './HockeyPlayerProfileForm';
import { BasketballPlayerProfileForm } from './BasketballPlayerProfileForm';
import { RacketPlayerProfileForm } from './RacketPlayerProfileForm';
import { VolleyballPlayerProfileForm } from './VolleyballPlayerProfileForm';
import { HandballPlayerProfileForm } from './HandballPlayerProfileForm';
import { SwimmingPlayerProfileForm } from './SwimmingPlayerProfileForm';
import { DefaultPlayerProfileForm } from './DefaultPlayerProfileForm';

interface Props extends PlayerProfileFormProps {
  sportType: SportType;
}

const PLAYER_PROFILE_FORMS: Partial<Record<SportType, ComponentType<PlayerProfileFormProps>>> = {
  football: FootballPlayerProfileForm,
  hockey: HockeyPlayerProfileForm,
  basketball: BasketballPlayerProfileForm,
  tennis: RacketPlayerProfileForm,
  padel: RacketPlayerProfileForm,
  volleyball: VolleyballPlayerProfileForm,
  handball: HandballPlayerProfileForm,
  swimming: SwimmingPlayerProfileForm,
  chess: DefaultPlayerProfileForm,
  poker: DefaultPlayerProfileForm,
  other: DefaultPlayerProfileForm,
};

export const PlayerSportProfileForm: React.FC<Props> = ({ sportType, value, onChange }) => {
  const Form = PLAYER_PROFILE_FORMS[sportType] ?? DefaultPlayerProfileForm;
  return <Form value={value} onChange={onChange} />;
};
